// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiApplicationDiscoveryModeSchema = z.enum(['CODE','BLACK_BOX','HYBRID','MANUAL'] as const);

export type AiApplicationDiscoveryModeType = `${z.infer<typeof AiApplicationDiscoveryModeSchema>}`

export default AiApplicationDiscoveryModeSchema;
